import { useTranslation } from 'react-i18next';
import { Icon, Modal } from '@seeqdev/qomponents';
import type { WorkbookApprovalFlow } from '@/worksheet/worksheet.types';

type ApprovalFlowModalProps = {
  isApplyingFlow?: boolean;
  approvalFlow: WorkbookApprovalFlow;
  isApplying: boolean;
  onSubmit: () => Promise<void>;
  onClose: () => void;
};

export const ApprovalFlowModal = ({
  isApplyingFlow = false,
  approvalFlow,
  isApplying,
  onSubmit,
  onClose,
}: ApprovalFlowModalProps) => {
  const { t } = useTranslation();
  const orderedSteps = [...approvalFlow.steps].sort((left, right) => left.position - right.position);
  const lockStep = orderedSteps.find((step) => step.lockRequired);

  return (
    <Modal
      open={true}
      onClose={onClose}
      onSubmit={onSubmit}
      disableSubmitButton={isApplying}
      submitButtonLabel={isApplyingFlow ? t('APPROVAL_FLOWS.APPLY') : t('DONE')}
      cancelButtonLabel={t('CANCEL')}
      testId="applyApprovalFlowModal"
      title={
        isApplyingFlow
          ? t('APPROVAL_FLOWS.APPLY_TITLE')
          : t('APPROVAL_FLOWS.VIEW_TITLE', { flowName: approvalFlow.name })
      }>
      <div className="tw:flex tw:flex-col tw:gap-4">
        {isApplyingFlow ? (
          <div className="tw:flex tw:flex-col tw:gap-4" data-testid="applyApprovalFlowDescription">
            <div>{t('APPROVAL_FLOWS.APPLY_DESCRIPTION', { flowName: approvalFlow.name })}</div>
            {lockStep && <div>{t('APPROVAL_FLOWS.APPLY_LOCK_DESCRIPTION', { lockStep: lockStep.name })}</div>}
          </div>
        ) : null}
        <div>
          <div className="tw:mb-2 tw:font-bold tw:text-inherit">{t('APPROVAL_FLOWS.STEPS')}</div>
          <ol className="tw:my-1 tw:flex tw:flex-col tw:gap-1 tw:pl-5">
            {orderedSteps.map((step) => (
              <li
                key={step.id}
                className="tw:flex tw:items-center tw:gap-1"
                data-testid={`applyApprovalFlowStep-${step.id}`}>
                <span>
                  ({step.position}) {step.name}
                </span>
                {step.lockRequired && (
                  <Icon
                    icon="fa-lock"
                    testId={`applyApprovalFlowStepLock-${step.id}`}
                    tooltip={t('APPROVAL_FLOWS.LOCK_REQUIRED')}
                  />
                )}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </Modal>
  );
};
